import { IBaseDocument } from '../types/document';
import { IFileFieldValue } from '../types/file';
import { fileSizeFormatter } from '../formatters';

export const mapDocumentToFieldValue = (document: IBaseDocument): IFileFieldValue => {
  return {
    name: document.name,
    id: document.id,
    size: fileSizeFormatter(document.size),
  };
};
